import { render, staticRenderFns } from "./IconCoding.vue?vue&type=template&id=9c298fea&"
import script from "./IconCoding.vue?vue&type=script&lang=js&"
export * from "./IconCoding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports